import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Operation } from '../../../models/operation.model';
import { Order } from '../../../models/order.model';
import { DateHelper } from '../../../helpers/date.helper';
import { PermissionHelper } from '../../../helpers/permission.helper';
import { ProductionPlanService } from '../../../services/production-plan.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-operation-item',
  templateUrl: './operation-item.component.html',
})

export class OperationItemComponent {
  @Input() order: Order;
  @Input() sector: string;
  @Input() isOpen: boolean;
  @Input() isSelectable: boolean;
  @Input() viewOptionKey: string;
  @Input() isQuantityEditable: boolean;
  @Input() operation: Operation;
  @Input() sliceStart: number;
  @Input() sliceEnd: number;
  datesWithPopulatedShifts: Array<any> = [];
  selectedOperation: Operation;
  isDetailsModalVisible: boolean;
  isDeviationModalOpen: boolean;
  isOperationDisplacementModal: boolean;

  @Output() readonly changeOperationTime = new EventEmitter();
  @Output() readonly changeOperationQuantity = new EventEmitter();

  constructor(public dateHelper: DateHelper,
              private productionPlan: ProductionPlanService,
              public permissionHelper: PermissionHelper,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.sector) {
        this.sector = params.sector;
      }
    });

    const yesterday = new Date().getTime() - 24*60*60*1000;

    this.datesWithPopulatedShifts = this.operation.dates
    .filter(date => date.shifts.some(shift => shift.quantityPlanned))
    .filter(item => new Date(item.date).getTime() > yesterday);
  }

  onSubmitOperationQuantity(workOrderOperationId, sector, date, shiftNumber, shiftQuantity): void {
    const quantityPlanned = shiftQuantity ? shiftQuantity : 0;

    const data = { workOrderOperationId, sector, date, shiftNumber, quantityPlanned };

    this.changeOperationQuantity.emit(data);
  }

  onCloseDetailsModal(event: boolean): void {
    this.isDetailsModalVisible = event;
  }

  onOpenDeviationModal(): void {
    this.isDeviationModalOpen = true;
  }

  onIgnoreDeviation(event: boolean): void {
    if (event) {
      this.productionPlan.ignoreDeviation(this.order.id, this.operation.id).subscribe(
        res => {
          this.operation.deviationFromPlan = false;
        }
      )
    }
    this.isDeviationModalOpen = false;
  }

  onChange(workOrderOperationId, date, shiftNumber, quantityPlanned): void {
    const tempObject = { key: { workOrderOperationId, date, shiftNumber }, quantityPlanned: quantityPlanned };

    this.productionPlan.onChangeOperationValue(tempObject);
  }

  onOpenOperationDisplacementModal(operation: Operation): void {
    this.selectedOperation = operation;
    this.isOperationDisplacementModal = true;
  }

  handleOperationDisplacementModal(): void {
    this.isOperationDisplacementModal = false;
  }

  trackByFn(index: number): number {
    return index;
  }
}
